import React from 'react';
import Button from 'components/ui/Button';
import { ModalShell } from 'components/ui/ModalFrame';
import { MODAL_LAYER } from 'constants/modalLayers';
import { MODAL_DIALOG_ACTIONS_END } from 'constants/layoutSpacing';
import { cn } from 'utils/cn';

const ClearEditorConfirmDialog = ({ open, onCancel, onConfirm }) => {
  if (!open) return null;

  return (
    <ModalShell
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/50"
      panelClassName="bg-card rounded-lg max-w-md w-full p-6 shadow-elevation-lg"
    >
      <h3 className="text-lg font-semibold text-foreground">Limpar editor</h3>

      <p className="text-sm text-muted-foreground mt-3">
        Ao limpar o editor, todo o conteúdo será apagado, junto com todas as variáveis
        criadas.
      </p>

      <div className={cn(MODAL_DIALOG_ACTIONS_END, 'mt-6')}>
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancelar
        </Button>
        <Button type="button" variant="destructive" onClick={onConfirm}>
          Limpar editor
        </Button>
      </div>
    </ModalShell>
  );
};

export default ClearEditorConfirmDialog;
